import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Line } from "three";

const AutoGenQuote = () => {
  const [showForm, setShowForm] = useState(true);
  const [QuoteHedNum, setQuoteHedNum] = useState(0);

  const [Structure, setStructure] = useState("");
  const [AvailableStructures, setAvailableStructures] = useState([]);
  const [AvailableIds,setAvailableIds] = useState([]);
  const [StructureId, setStructureId] = useState("");
  const [Lines, setLines] = useState([]);
  const toggleForm = () => {
    setShowForm(!showForm);
  };
  const GetLines = () => {
    axios.get(`https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/AutoPartFetcher(PRECAST)/?PartNum=${Structure}&RevisionNum=${StructureId}`,
  {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa("manager:manager")}`

    }}
  ).then((response) => {
   setLines(response.data.value);

  }).catch((error) => {
    toast.error(error.message);
  });
  };
  React.useEffect(() => {
    axios
      .get(
        "https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/StructuresLines(PRECAST)",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${btoa("manager:manager")}`
          }
        }
      )
      .then((response) => {
        setAvailableStructures(
          response.data.value.map((structure) => structure["Part_PartNum"])
        );
        setStructure(response.data.value[0]["Part_PartNum"]);
        setAvailableIds(
          response.data.value.map((structure) => structure["ECOMtl_RevisionNum"])
        );
        setStructureId(response.data.value[0]["ECOMtl_RevisionNum"]);
      })
      .catch((error) => {
        toast.error(error.message);
      });
  }, []);
  return (
    <>
      <div className="Form-Panel m-1 px-2 py-2">
        <div className="title-border-bottom">
          <button className="toggle-btn my-3 mx-5" onClick={toggleForm}>
            <i
              className="bi bi-arrow-down-short"
              style={{
                fontSize: "2rem",
                fontWeight: "bolder"
              }}
            ></i>
            Quote Details
          </button>
        </div>

        {showForm && (
          <div className="mb-2">
            <form className="p-2 m-2 form-bg border rounded">
              <div className="container">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group my-2">
                      <label htmlFor="moldSelect">Structure</label>
                      <select
                        type="text"
                        id="moldSelect"
                        className="form-select"
                        onChange={(e) => {
                          setStructure(e.value);
                          console.log(e.value);
                        }}

                        value={Structure}
                        name="optionlist"
                      >
                        {[...new Set(AvailableStructures)].map(
                          (structure, index) => {
                            return (
                              <option key={index + 1} value={structure}>
                                {structure}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group my-2">
                      <label htmlFor="moldSelect">Id</label>
                      <select
                        type="text"
                        id="moldSelect"
                        className="form-select"
                        onChange={(e) => {
                          setStructureId(e.value);
                        }}

                        value={StructureId}
                        name="optionlist"
                        defaultValue=""
                      >{
                        [...new Set(AvailableIds)].map(
                          (Id, index) => {
                            return (
                              <option key={index + 1} value={Id}>
                                {Id}
                              </option>
                            );
                          }
                      )}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4 m-auto">
                  <button
                  type="button"
                  className="submit-btn ro d-block m-4 rounded "
                  onClick={() => {GetLines()}}
                >
                 Get Lines
                </button>
                  </div>
                </div>
                <button
                  type="button"
                  className="submit-btn ro d-block m-2 rounded"
                  onClick={() => {}}
                >
                  Generate Quote
                </button>
              </div>
            </form>
          </div>
        )}
        <ToastContainer />
      </div>
      {Lines.length > 0 &&
      <div className='card-body'>
        <h2>Part BOM</h2>
            <div className='table-responsive'>
              <div className='scrollable-table-body table-bordered'>
                <table className='table table-bordered-hollow'>
                  <thead className='table-primary'>
                    <tr className='bg-primary text-white'>
                      <th>Part Num</th>
                      <th>Description</th>
                      <th>Width</th>
                      <th>Height</th>
                      <th>Diameter</th>
                      <th>Length</th>

                    </tr>
                  </thead>
                  <tbody>

             {Lines.map((line, index) => {
                return (
                  <tr key={index}>
                    <td>{line["ECOMtl_MtlPartNum"]}</td>
                    <td>{line["Part_PartDescription"]}</td>
                    <td>{line.Part_PartWidth}</td>
                    <td>{line.Part_PartHeight}</td>
                    <td>{line.Part_Diameter}</td>
                    <td>{line.Part_PartLength}</td>
                  </tr>
                );
              }
              )
             }

                  </tbody>
                </table>
              </div>
            </div>
          </div>
}
    </>
  );
};

export default AutoGenQuote;
